function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
export const CheckmarkIcon = (_0)=>{
    let { color = '#fff' } = _0, props = _object_without_properties(_0, [
        "color"
    ]);
    return /*#__PURE__*/ _jsx("svg", _object_spread_props(_object_spread({
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M20.6177 5.83302C20.4986 5.71297 20.357 5.61769 20.2009 5.55266C20.0448 5.48764 19.8774 5.45416 19.7084 5.45416C19.5393 5.45416 19.3719 5.48764 19.2158 5.55266C19.0597 5.61769 18.9181 5.71297 18.799 5.83302L9.25712 15.3877L5.24826 11.366C5.12463 11.2466 4.9787 11.1527 4.81878 11.0897C4.65887 11.0267 4.48811 10.9958 4.31625 10.9987C4.1444 11.0017 3.97481 11.0385 3.81717 11.107C3.65953 11.1755 3.51693 11.2744 3.39752 11.398C3.2781 11.5217 3.1842 11.6676 3.12118 11.8275C3.05816 11.9874 3.02725 12.1582 3.03023 12.33C3.0332 12.5019 3.06999 12.6715 3.13851 12.8291C3.20702 12.9868 3.30591 13.1294 3.42954 13.2488L8.34776 18.167C8.46683 18.2871 8.60848 18.3823 8.76456 18.4474C8.92064 18.5124 9.08804 18.5459 9.25712 18.5459C9.4262 18.5459 9.59361 18.5124 9.74968 18.4474C9.90576 18.3823 10.0474 18.2871 10.1665 18.167L20.6177 7.71578C20.7477 7.59584 20.8515 7.45028 20.9224 7.28826C20.9934 7.12624 21.03 6.95128 21.03 6.7744C21.03 6.59752 20.9934 6.42256 20.9224 6.26054C20.8515 6.09852 20.7477 5.95295 20.6177 5.83302Z",
            fill: color
        })
    }));
};
